import { useTranslation } from 'react-i18next';

const RTL_LANGUAGES = [
  'ar', // Arabic
  'he', // Hebrew
  'fa', // Persian
  'pnb', // Punjabi (Shahmukhi)
  'ur' // Urdu
];

const LANGUAGE_MAP = {
  arabic: 'ar',
  hebrew: 'he',
  persian: 'fa',
  'punjabi (shahmukhi)': 'pnb',
  urdu: 'ur'
};

const normalizeToCode = (input) => {
  if (!input) {
    return null;
  }

  const normalized = input.toLowerCase();

  // Handle codes like "ar-SA"
  if (normalized.includes('-')) {
    return normalized.split('-')[0];
  }

  return LANGUAGE_MAP[normalized] || normalized;
};

const getDir = (input) => {
  const code = normalizeToCode(input);
  return RTL_LANGUAGES.includes(code) ? 'rtl' : 'ltr';
};

const isRTLLanguageByName = (language) => {
  return getDir(language);
}

const isRTLLanguageById = (languages, languageId) => {
  const match = languages?.find(lg => lg.id === languageId);
  return getDir(match?.name);
};

const isRTLLanguageByCode = (languageCode) => {
  return getDir(languageCode);
};

const useRTL = () => {
  const { i18n } = useTranslation();
  const dir = getDir(i18n.language?.split('-')[0]);
  const isRTL = dir === 'rtl';
  return { isRTL, dir };
};

export default useRTL;
export {
  isRTLLanguageByName,
  isRTLLanguageById,
  isRTLLanguageByCode
};